<template>
  <router-view></router-view>
</template>

<script lang="ts">
  import { RouterLink, RouterView } from 'vue-router'

  import { useLayoutStore } from './modules/global/stores/layout'

  export default {
    components: {
    },
    mounted() {
      useLayoutStore().init()
    },
  }
</script>
